import React, { useEffect, useState } from 'react'
import styles from './PreviewChallan.module.css'

import generatePDF, { Margin, Resolution, usePDF } from 'react-to-pdf';
import { numberToWords } from '../../Helpers/Calci';
import ChallanLogo from '../../Components/Challans/ChallanLogo';


const PreviewChallan = (props) => {
    const { isOpen, activeUser, toggleInvoiceGenerator } = props
    const [totalItemsQuantity, setTotalItemsQuantity] = useState(0)
    const [totalBasePrice, setTotalBasePrice] = useState(0)
    const [totalGst, setTotalGst] = useState(0)
    const [totalPriceWithGst, setTotalPriceWithGst] = useState(0)
    const [gstType, setGstType] = useState('IGST') // SGST

    window.onclick = event => event.target.id === "mcmpreviewChallan" ? toggleInvoiceGenerator() : null
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            toggleInvoiceGenerator()
        }
    });

    const [cartItems, setCartItems] = useState([
        {
            id: 1,
            productTitle: 'Trolley Wild Craft',
            quantity: "1",
            basePrice: "1800",
            hsn: '42022990'
        },
        {
            id: 2,
            productTitle: 'Courier Charges',
            quantity: "1",
            basePrice: "500",
            hsn: ''
        },
    ])


    const calculateSumOfBasePrice = (products) => {
        return products.reduce((sum, product) => {
            // Convert basePrice to a number (since it's a string) and add it to the sum
            return sum + (parseFloat(product.basePrice) || 0);  // Handling case if basePrice is not a number
        }, 0);
    };

    const calculateTotalGst = (products) => {
        return products.reduce((totalGst, product) => {
            // Convert basePrice to a number and calculate GST (18% of basePrice)
            return totalGst + (parseFloat(product.basePrice) * 0.18 || 0);  // Handling case if basePrice is not a number
        }, 0);
    };

    // console.log(activeUser)
    // console.log(cartItems)

    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });

    const options = {
        resolution: Resolution.MEDIUM,
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL,
            // default is 'A4'
            // format: 'letter',
            // default is 'portrait'
            // orientation: 'landscape',
        },
        filename: `${activeUser?.phoneNumber}_${activeUser?.city?.trim()?.toUpperCase()}.pdf`

    };


    const getTargetElement = () => document.getElementById('content-id');


    const totalQuantity = () => cartItems?.reduce((acc, item) => {
        const quantity = item.quantity !== null && item.quantity.trim() !== ''
            ? parseFloat(item.quantity)
            : 0;
        return acc + quantity;
    }, 0)

    const totalPrice = () => cartItems?.reduce((acc, item) => {
        // Handle null/empty quantity and basePrice
        const quantity = parseFloat(item.quantity?.trim() || 0);
        const basePrice = parseFloat(item.basePrice?.trim() || 0);

        return acc + (quantity * basePrice);
    }, 0);

    const getTotalGst = () => cartItems?.reduce((acc, item) => {
        // Handle null/empty quantity and basePrice
        const tpwGst = parseFloat(item.totalPrice?.trim() || 0);

        return acc + tpwGst
    }, 0);

    const getTotalPriceWithGst = () => cartItems?.reduce((acc, item) => {
        // Handle null/empty quantity and basePrice
        const tpwGst = parseFloat(item.totalPrice?.trim() || 0);

        return acc + tpwGst
    }, 0);

    const calculateTotalAmountWithGst = (products) => {
        return products.reduce((totalAmount, product) => {
            // Convert basePrice to a number, then add GST (18% of basePrice)
            const basePrice = parseFloat(product.basePrice) || 0;
            const gstAmount = basePrice * 0.18;
            return totalAmount + (basePrice + gstAmount);  // Base price + 18% GST
        }, 0);
    };


    useEffect(() => {
        setTotalItemsQuantity(totalQuantity())
        setTotalBasePrice(totalPrice())
        setTotalPriceWithGst(getTotalPriceWithGst())
    }, [cartItems])

    useEffect(() => {
        setTotalGst(getTotalGst() - totalBasePrice)
    }, [totalBasePrice])

    // Function to handle key press
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            generatePDF(getTargetElement, options)
            // console.log('Enter key pressed globally!');
            // alert('You pressed Enter!');
        }
    };

    useEffect(() => {

        // Adding the event listener to the window object
        window.addEventListener('keydown', handleKeyPress);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);


    if (!isOpen) {
        return null
    }


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer} id="mcmpreviewChallan">
                <div>
                    <button onClick={() => toggleInvoiceGenerator()}>Close</button>
                </div>
                <div className={styles.mainContent}>
                    <div className={styles.mainHeader}>
                        Generate Invoice
                    </div>
                    <div className={styles.mainBody}>
                        <div className={styles.invoiceWrapper}
                            ref={targetRef}
                            id="content-id"
                        >
                            <div className={styles.iwHeaderWrapper}>
                                <div className={styles.iwhLeftWrapper}>
                                    <div className={styles.logoWrapper}>
                                        {/* <img src="https://stylelink.s3.ap-south-1.amazonaws.com/qnnox-assets/master-file-Qnnox-logo_512x512.png" /> */}
                                        <img src="data:image/png;base64,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" />
                                    </div>
                                    <div>
                                        <div className={styles.firmName}>
                                            Caliber Inno Enterprise Pvt Ltd
                                        </div>
                                        <div className={styles.firmAddress}>
                                            1/1 1st Floor Ashirwad Appartment
                                            Puliyur 1st Main Road, Trust Puram, Kodambakkam
                                            Chennai, Tamil Nadu - 600024
                                        </div>

                                    </div>
                                </div>
                                <div className={styles.iwhRightWrapper}>
                                    <div className={styles.pocName}>
                                        Name : Surendra
                                    </div>
                                    <div className={styles.pocPhone}>
                                        Phone : 9962255445
                                    </div>
                                    <div className={styles.pocEmail}>
                                        Email : Surendra@caliberinno.com
                                    </div>
                                </div>
                            </div>

                            <div className={styles.tableWrapper}>
                                <div className={styles.tableMainHeader}>
                                    <div className={styles.tableMainHeaderTxt}>
                                        DELIVERY CHALLAN
                                    </div>
                                    <div className={styles.tmhSecondLineWrapper}>
                                        <div>
                                            GST : 33AAFCC7149G1ZQ
                                        </div>
                                        <div>
                                            Original For Recipient
                                        </div>
                                    </div>
                                </div>


                                <div className={styles.cdDateWrapper}>
                                    <div className={styles.cdWrapper}>
                                        <div className={styles.cdHeader}>
                                            Customer Details
                                        </div>
                                        <div>
                                            <div className={styles.eachFirmWrapper}>
                                                <div className={styles.efwCaption}>M/S</div>
                                                <div className={styles.efwValue}>{activeUser?.firstName} {activeUser?.middleName} {activeUser?.lastName} </div>
                                            </div>
                                            <div className={styles.eachFirmWrapper}>
                                                <div className={styles.efwCaption}>Address</div>
                                                <div className={styles.efwValue}>{activeUser?.address}</div>
                                            </div>
                                            <div className={styles.eachFirmWrapper}>
                                                <div className={styles.efwCaption}>Phone</div>
                                                <div className={styles.efwValue}>{activeUser?.phoneNumber}</div>
                                            </div>

                                            <div className={styles.eachFirmWrapper}>
                                                <div className={styles.efwCaption}>GSTIN</div>
                                                <div className={styles.efwValue}>{activeUser?.gstNumber}</div>
                                            </div>
                                            <div className={styles.eachFirmWrapper}>
                                                <div className={styles.efwCaption}>Place of Supply</div>
                                                <div className={styles.efwValue}>Tamil Nadu ( 33 )</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className={styles.dateWrapper}>
                                        <div className={styles.dwLeftWrapper}>
                                            <div className={styles.eachFieldWrapper}>
                                                <div className={styles.efwCaption}>Challan No.</div>
                                                <div className={styles.efwValue}>{activeUser?.ID}</div>
                                            </div>
                                        </div>
                                        <div className={styles.dwRightWrapper}>
                                            <div className={styles.eachFieldWrapper}>
                                                <div className={styles.efwCaption}>Challan Date</div>
                                                <div className={styles.efwValue}>21-Oct-2024</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.gapWrapper}>

                                </div>

                                <div className={styles.productsTableWrapper}>
                                    <div className={styles.ptwHeaderWrapper}>
                                        <div className={styles.sn}>
                                            #
                                        </div>
                                        <div className={styles.particular}>
                                            Item(s) / Particular(s)
                                        </div>
                                        <div className={styles.hsnMain}>
                                            HSN / SAC
                                        </div>
                                        <div className={styles.qty}>
                                            Qty
                                        </div>
                                        <div className={styles.rate}>
                                            Rate
                                        </div>
                                        <div className={styles.taxableMain}>
                                            Taxable Value
                                        </div>
                                        {gstType === "SGST" &&
                                            <div className={styles.sgst}>
                                                <div>CGST</div>
                                                <div className={styles.taxSmallRow}>
                                                    <div>%</div>
                                                    <div>Amt.</div>
                                                </div>
                                            </div>
                                        }
                                        {gstType === "SGST" &&
                                            <div className={styles.cgst}>
                                                <div>SGST</div>
                                                <div className={styles.taxSmallRow}>
                                                    <div>%</div>
                                                    <div>Amt.</div>
                                                </div>
                                            </div>
                                        }
                                        {gstType === "IGST" &&
                                            <div className={styles.igst}>
                                                <div className={styles.taxUpperRow}>IGST</div>
                                                <div className={styles.taxSmallRow}>
                                                    <div className={styles.tsrEach} >%</div>
                                                    <div className={styles.tsrEach} >Amt.</div>
                                                </div>
                                            </div>
                                        }
                                        <div className={styles.totalColWrapper}>
                                            Total
                                        </div>
                                    </div>

                                    <div className={styles.productRowsWrapper}>
                                        {cartItems?.map((item, index) => (
                                            <div key={index} className={styles.ptwRowWrapper}>
                                                <div className={styles.sn}>
                                                    {index + 1}
                                                </div>
                                                <div className={styles.particular}>
                                                    {item?.productTitle}
                                                </div>
                                                <div className={styles.hsnMain}>
                                                    {item?.hsn}
                                                </div>
                                                <div className={styles.qtyValue}>
                                                    {item?.quantity}
                                                </div>
                                                <div className={styles.rateValue}>
                                                    ₹{item?.basePrice}
                                                </div>
                                                <div className={styles.taxableMainValue}>
                                                    ₹{parseFloat(item?.basePrice) * parseFloat(item?.quantity)}
                                                </div>
                                                {gstType === "SGST" &&
                                                    <div className={styles.sgst}>
                                                        <div className={styles.taxSmallRow}>
                                                            <div>2.5</div>
                                                            <div>Amount</div>
                                                        </div>
                                                    </div>
                                                }
                                                {gstType === "SGST" &&
                                                    <div className={styles.cgst}>
                                                        <div className={styles.taxSmallRow}>
                                                            <div>2.5</div>
                                                            <div>Amount</div>
                                                        </div>
                                                    </div>
                                                }
                                                {gstType === "IGST" &&
                                                    <div className={styles.igst}>
                                                        <div className={styles.taxSmallRow}>
                                                            <div className={styles.tsrEach} >18</div>
                                                            <div className={styles.tsrEach} >
                                                                ₹{parseFloat(item?.basePrice) * parseFloat(item?.quantity) * (0.18)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className={styles.totalColWrapper}>
                                                    ₹{parseFloat(item?.basePrice) * parseFloat(item?.quantity) * (1.18)}
                                                </div>


                                            </div>
                                        ))}

                                    </div>
                                    <div className={styles.totalWrapper}>
                                        <div className={styles.totalTxtCol}>
                                            Total
                                        </div>
                                        <div className={styles.qtyTotal}>
                                            {totalItemsQuantity}
                                        </div>
                                        <div className={styles.rateTotal}>
                                            -
                                        </div>
                                        <div class={styles.taxableMain}>
                                            {calculateSumOfBasePrice(cartItems)}
                                        </div>
                                        {gstType === "SGST" &&
                                            <div className={styles.sgst}>
                                                <div className={styles.taxSmallRow}>
                                                    <div>%</div>
                                                    <div>Amount</div>
                                                </div>
                                            </div>
                                        }
                                        {gstType === "SGST" &&
                                            <div className={styles.cgst}>
                                                <div className={styles.taxSmallRow}>
                                                    <div>%</div>
                                                    <div>Amount</div>
                                                </div>
                                            </div>
                                        }
                                        {gstType === "IGST" &&
                                            <div className={styles.igst}>
                                                <div className={styles.taxSmallRow}>
                                                    <div className={styles.tsrEach} >

                                                    </div>
                                                    <div className={styles.tsrEach} >
                                                        {calculateTotalGst(cartItems)}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className={styles.amountTotal}>
                                            ₹{calculateTotalAmountWithGst(cartItems)}
                                        </div>
                                    </div>


                                    <div className={styles.totalInWordsAndAmountWrapper}>
                                        <div className={styles.inWordsWrapper}>
                                            <div className={styles.inWordsTxtTitle}>
                                                Total In words
                                            </div>
                                            <div className={styles.inWordsTxt}>
                                                {numberToWords(calculateTotalAmountWithGst(cartItems))} Rupees Only
                                            </div>
                                        </div>
                                        <div className={styles.tinAmountWrapper}>
                                            <div className={styles.tinTaxableAmount}>
                                                <div className={styles.tinTitle}>Taxable Amount</div>
                                                <div className={styles.tinValue}>
                                                    {parseFloat(calculateSumOfBasePrice(cartItems)).toFixed(2)}
                                                </div>
                                            </div>
                                            <div className={styles.tinIgst}>
                                                <div className={styles.tinTitle}>Add IGST</div>
                                                <div className={styles.tinValue}>18%</div>
                                            </div>
                                            <div className={styles.tinTotalTax}>
                                                <div className={styles.tinTitle}>Total Tax</div>
                                                <div className={styles.tinValue}>{calculateTotalGst(cartItems)}</div>
                                            </div>
                                            <div className={styles.tinTotalAmount}>
                                                <div className={styles.tinTitle}>Total Amount After Tax</div>
                                                <div className={styles.tinValue}>₹{calculateTotalAmountWithGst(cartItems)}</div>
                                            </div>

                                            <div className={styles.iwwTop}>
                                                <div></div>
                                                <div>(E. & O.E.)</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className={styles.bnSignatoryWrapper}>
                                    <div className={styles.bankDetailsWrapper}>
                                        <div className={styles.bankDetailsTitle}>
                                            Bank Details
                                        </div>
                                        <div className={styles.bankDetailsContainer}>
                                            <div className={styles.bdcLeftWrapper}>
                                                <div className={styles.eachBdWrapper}>
                                                    <div>Name</div>
                                                    <div>ICICI Bank</div>
                                                </div>

                                                <div className={styles.eachBdWrapper}>
                                                    <div>Account No.</div>
                                                    <div>270205001420</div>
                                                </div>
                                            </div>

                                            <div className={styles.bdcRightWrapper}>

                                                <div className={styles.eachBdWrapper}>
                                                    <div>Branch</div>
                                                    <div>Kovilambakkam</div>
                                                </div>

                                                <div className={styles.eachBdWrapper}>
                                                    <div>IFSC</div>
                                                    <div>ICICO002702</div>
                                                </div>

                                            </div>

                                        </div>
                                        <div className={styles.tncWrapper}>
                                            Terms and Conditions
                                        </div>
                                        <div className={styles.tncNotes}>
                                            <div>
                                                Subject to our home Jurisdiction.
                                            </div>
                                            <div>
                                                Our Responsibility Ceases as soon as goods leaves our Premises.
                                            </div>
                                            <div>
                                                Goods once sold will not taken back.
                                            </div>
                                            <div>
                                                Delivery Ex-Premises.
                                            </div>
                                        </div>
                                        <div className={styles.tncWrapper}>
                                            Terms and Conditions
                                        </div>
                                    </div>
                                    <div className={styles.authSignatoryWrapper}>
                                        <div className={styles.certiInfoTxt}>
                                            <div className={styles.certified}>
                                                Certified that the particulars given above are
                                                true and correct.
                                            </div>
                                            <div className={styles.forInfo}>
                                                For Caliber Inno Enterprise Pvt Ltd
                                            </div>
                                        </div>

                                        <div>
                                            <ChallanLogo />
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className={styles.mainFooter}>
                        <div>
                            <button>Edit</button>
                        </div>
                        <div className={styles.rightAction}>
                            {/* <button className={styles.downloadBtn} onClick={() => toPDF()} >Download</button> */}
                            <button className={styles.downloadBtn} onClick={() => generatePDF(getTargetElement, options)} >Download</button>
                            <button className={styles.printBtn}>Print</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default PreviewChallan
